import React from "react";
import "./App.css";
import Loading from "./loading.js";
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch,
} from "react-router-dom";
import Response from "./Response";
import PanelResponse from "./PanelResponse";
import ThankYou from "./ThankYou";

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      authenticated: false,
      done: false,
      name: "",
      phoneNumber: "",
      inviteCode: undefined,
      linkSentTime: undefined,
      slotTime: {
        timeslot1: { start: "09:00", end: "12:00" },
        timeslot2: { start: "12:00", end: "15:00" },
        timeslot3: { start: "15:00", end: "18:00" },
      },
      header: "Sample Header",
      footer: "Sample Footer",
    };
    this.doneHandler = this.doneHandler.bind(this);
    this.stateHandler = this.stateHandler.bind(this);
  }
  doneHandler = (e) => {
    this.setState({ done: true });
  };
  stateHandler = (rcvdState) => {
    let name = rcvdState.name;
    let phoneNumber = rcvdState.phoneNumber;
    let inviteCode = rcvdState.inviteCode;
    let slotTime = {
      timeslot1: {
        start: rcvdState.slotTime.timeslot1.start,
        end: rcvdState.slotTime.timeslot1.end,
      },
      timeslot2: {
        start: rcvdState.slotTime.timeslot2.start,
        end: rcvdState.slotTime.timeslot2.end,
      },
      timeslot3: {
        start: rcvdState.slotTime.timeslot3.start,
        end: rcvdState.slotTime.timeslot3.end,
      },
    };
    let header = rcvdState.header;
    let footer = rcvdState.footer;
    let linkSentTime = rcvdState.linkSentTime;
    this.setState({
      name: name,
      phoneNumber: phoneNumber,
      inviteCode: inviteCode,
      slotTime: slotTime,
      header: header,
      footer: footer,
      linkSentTime: linkSentTime,
      done: true,
      authenticated: true,
    });
  };
  render() {
    return (
      <div className="App">
        <Router>
          <Switch>
            <Route path="/" exact>
              <header className="App-header">
                <Loading
                  doneHandler={this.doneHandler}
                  done={this.state.done}
                  stateHandler={this.stateHandler}
                ></Loading>
              </header>
            </Route>
            <Route path="/loader" exact>
              <header className="App-header">
                <Loading
                  doneHandler={this.doneHandler}
                  done={this.state.done}
                  stateHandler={this.stateHandler}
                ></Loading>
              </header>
            </Route>
            <Route path="/response" exact>
              <Response
                name={this.state.name}
                phoneNumber={this.state.phoneNumber}
                inviteCode={this.state.inviteCode}
                slotTime={this.state.slotTime}
                header={this.state.header}
                footer={this.state.footer}
                linkSentTime={this.state.linkSentTime}
              ></Response>
            </Route>
            <Route path="/panelresponse" exact>
              <PanelResponse
                name={this.state.name}
                phoneNumber={this.state.phoneNumber}
                inviteCode={this.state.inviteCode}
                slotTime={this.state.slotTime}
                header={this.state.header}
                footer={this.state.footer}
                linkSentTime={this.state.linkSentTime}
              ></PanelResponse>
            </Route>
            <header className="App-header-2">
              <Route path="/thankyou" exact>
                <ThankYou name={this.state.name}></ThankYou>
              </Route>
            </header>
            <Redirect to="/"></Redirect>
          </Switch>
        </Router>
      </div>
    );
  }
}

export default App;
